export default (email) =>{
    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))
        return (true)
    return (false)
}